{
  "AllSetTitle": "You're all set",
  "AllSetSubtitle": "No questionnaires are available for you right now.",
  "Back": "Back",
  "Cancel": "Cancel",
  "CompletedAtDate": "Completed at {{at}}",
  "ConsentDeclinedSubtitle": "You have declined to take part. Your study team is available if you have questions.",
  "ConsentDeclinedTitle": "Consent declined",
  "DevDataExport": "[DEV] Data Export",
  "DevDebug": "[DEV] Debug",
  "DevDemo": "[DEV] Demo",
  "Done": "Done",
  "EnrollmentClosedSubtitle": "The time to complete this step has passed. Your study team is available if you have questions.",
  "EnrollmentClosedTitle": "Enrollment closed",
  "EnrollmentCompleteSubtitle": "Your consent is signed. There's nothing more to do here right now — your study team will be in touch.",
  "EnrollmentCompleteSubtitlePrescreenOnly": "There's nothing more to do here right now — your study team will be in touch.",
  "EnrollmentCompleteTitle": "You're all set — consent signed",
  "EnrollmentCompleteTitlePrescreenOnly": "You're all set",
  "EnrollmentEyebrowConsent": "Step 2 of 2 · Informed consent",
  "EnrollmentEyebrowConsentOnly": "Informed consent",
  "EnrollmentEyebrowPrescreen": "Step 1 of 2 · Pre-screening",
  "EnrollmentEyebrowPrescreenOnly": "Pre-screening",
  "EnrollmentFooter": "Taking part is voluntary. You can stop at any time.",
  "EnrollmentHeroBodyConsent": "Please read the consent form carefully. You can ask your study team anything before you sign, and you may withdraw at any time.",
  "EnrollmentHeroBodyPrescreen": "Answer a few short questions about your health. It takes about 5 minutes, and your answers are kept private.",
  "EnrollmentHeroCtaConsent": "Review & sign consent",
  "EnrollmentHeroCtaConsentResume": "Continue consent review",
  "EnrollmentHeroCtaPrescreen": "Start pre-screening",
  "EnrollmentHeroCtaPrescreenResume": "Continue pre-screening",
  "EnrollmentHeroTitleConsent": "You're eligible — review your consent",
  "EnrollmentHeroTitleConsentOnly": "Review your consent",
  "EnrollmentHeroTitlePrescreen": "Let's see if this study is right for you",
  "EnrollmentSectionLabel": "Your enrollment",
  "EnrollmentStepConsentBlurb": "Review and sign your consent form",
  "EnrollmentStepConsentName": "Informed consent",
  "EnrollmentStepDone": "Done",
  "EnrollmentStepNext": "Next",
  "EnrollmentStepPrescreeningBlurb": "A few questions to check this study is right for you",
  "EnrollmentStepPrescreeningName": "Pre-screening",
  "ErrorUpdatingUser": "Error updating user",
  "ExternalIdMissingSubtitle": "Open the study again from the place where you signed up.",
  "ExternalIdMissingTitle": "We couldn't open this study",
  "Failure": "Failure",
  "Finish": "Finish",
  "FormProgress": "Form progress: {{progress}}%",
  "Home": "Home",
  "HomeSeeAllTasks": "See all upcoming tasks in Schedule",
  "HomeTasksToday": "Tasks for today, {{date}}",
  "Language": "Language",
  "Leave": "Leave",
  "Loading": "Loading",
  "loadingScreenDoNotCloseMessage": "This may take a moment. Please do not close this page.",
  "LogOut": "Log out",
  "LogoutConfirmationBody": "Are you sure you want to log out?",
  "LogoutConfirmationHeader": "Logout",
  "More": "More",
  "MyStudies": "My Studies",
  "Next": "Next",
  "NoSchedule": "No schedule assigned",
  "NoScheduleDescription": "You’ll see your tasks here as soon as a schedule has been assigned to you.",
  "NoScheduleForMonth": "No tasks this month",
  "NoScheduleForMonthDescription": "You currently have no tasks scheduled for this month. You can view later months for any upcoming tasks.",
  "NoScheduleForWeek": "No tasks this week",
  "NoScheduleForWeekDescription": "You currently have no tasks scheduled for this week. You can view later weeks for any upcoming tasks.",
  "NotAnswered": "Not answered",
  "NoTasksForToday": "You don’t have any tasks for today.",
  "NotFoundSubtitle": "The page you’re looking for doesn’t exist.",
  "NotImplementedYet": "Coming soon...",
  "OfflineWarning": "You are offline. Please check your internet connection.",
  "Previous": "Previous",
  "Processing": "Processing",
  "QuestionnaireCompleteFailureMessage": "Failed to complete questionnaire. Please try again.",
  "questionnaireInitializationLoadingTitle": "Setting up your questionnaire",
  "QuestionnaireRedirecting": "Redirecting...",
  "QuestionnaireLeaveWarningMessage": "Your progress is saved, but the assessment isn't formally submitted. If you leave now, you'll need to resume later to complete it.",
  "QuestionnaireLeaveWarningTitle": "Not finished yet?",
  "PostQuestionnaireLeaveWarningMessage": "Your questionnaire has been submitted. You can review the remaining information now, or come back to it later.",
  "PostQuestionnaireLeaveWarningTitle": "Almost done!",
  "preScreeningBadge": "screening",
  "QuestionnaireNotAvailableNow": "This questionnaire is not available now",
  "QuestionnaireNotAvailableSubtitle": "Your questionnaire is finished or not accessible at this time.",
  "PreScreeningCompleteTitle": "Screening complete",
  "PreScreeningCompleteSubtitle": "Thanks — there's nothing more to do here right now.",
  "QuestionnaireNotAvailableTitle": "Nothing to see here",
  "questionnaireSubmissionLoadingTitle": "Saving your responses",
  "QuestionnaireSummaryDescription": "Thank you for completing this questionnaire. Please review your answers and submit when you’re finished.",
  "QuestionnaireUpdateFailureMessage": "Failed to update questionnaire. Please try again.",
  "QuestionnaireValidationErrorOnPreviousPage": "Some answers on a previous page are no longer valid. Please correct them before continuing.",
  "ProtocolEditor": "Protocol Editor",
  "ProtocolList": "Protocols",
  "Brands": "Brands",
  "Save": "Save",
  "Schedule": "Schedule",
  "ScheduleDayTasks_one": "{{count}} task",
  "ScheduleDayTasks_other": "{{count}} tasks",
  "SessionExpiryBody_one": "For your security, you’ll be signed out in {{count}} second.",
  "SessionExpiryBody_other": "For your security, you’ll be signed out in {{count}} seconds.",
  "SessionExpiryStay": "Stay signed in",
  "SessionExpiryTitle": "Still there?",
  "ShellAccountButtonLabel": "Account",
  "ShellAccountDevSectionLabel": "Developer & admin",
  "ShellDarkModeLabel": "Dark mode",
  "ShellNavLabel": "Main navigation",
  "SignedOutBody": "For your security, you’re signed out after {{minutes}} minutes without activity. Answers you already saved are kept.",
  "SignedOutSignInAgain": "Sign in again",
  "SignedOutTitle": "You were signed out",
  "SkipToContent": "Skip to content",
  "SomethingWentWrongSubtitle": "An unexpected error occurred. Please try again. If the problem persists, contact support.",
  "SomethingWentWrongTitle": "Something went wrong",
  "Stay": "Stay",
  "StudyInfo": "Study Info",
  "studyParticipationBadge": "participation",
  "Success": "Success",
  "Surveys": "Questionnaires",
  "SystemInfo": "System Info",
  "TaskRowAvailableNow": "Available now",
  "TaskRowDue": "Due {{time}}",
  "TaskRowOpenUntil": "Open until {{time}}",
  "TaskRowOpens": "Opens {{time}}",
  "TaskRowOpensUntil": "Opens\u00a0{{opens}}, until\u00a0{{until}}",
  "Today": "Today",
  "TranslationNotInManifest": "Translation file is not specified in manifest ({{assetId}}, {{language}})",
  "UserUpdated": "User updated",
  "authError": {
    "connection": {
      "title": "Connection Error",
      "message": "Unable to connect to the authentication service. Please check your internet connection and try again."
    },
    "authService": {
      "title": "Authentication Failed",
      "message": "Authentication failed. Please try again."
    },
    "unknown": {
      "title": "Unexpected Error",
      "message": "An unexpected error occurred during authentication. Please try again."
    },
    "tryAgain": "Try again"
  }
}
